const scrollToTop = () => {
  if ('scrollBehavior' in document.documentElement.style) {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    return;
  }

  $('html, body').stop().animate({ scrollTop: 0 }, 400);
};

const backToTop = () => {
  console.log();
  const $btn = $('#backToTop');
  console.log($btn);
  if (!$btn.length) return;

  $(window).on('scroll.backToTop', function () {
    if ($(window).scrollTop() > $(window).height()) {
      $btn.fadeIn();
    } else {
      $btn.fadeOut();
    }
  });

  $btn.on('click.backToTop', function (e) {
    e.preventDefault();
    scrollToTop();
  });
};

export default backToTop;
